import { Box } from '@chakra-ui/react';
import { TTAPostSnippet } from '~/screens/GlobalSearchScreen/components/TTASearch/TTAPostSnippet/TTAPostSnippet';
import { CreatorInfoDesktop } from '~/screens/MyAgency/components/StackView/CreatorInfo/CreatorInfoDesktop';
import { CreatorInfoMobile } from '~/screens/MyAgency/components/StackView/CreatorInfo/CreatorInfoMobile';
import { ICreator } from '~/types';

interface ICreatorInfoProps {
  creator: ICreator;
  note?: string;
  isProfile?: boolean;
  isShared?: boolean;
  onCheck?: (isChecked: boolean) => void;
  onNoteOpen?: () => void;
  onNameClick?: () => void;
  onRemoveFromList?: (creator: ICreator) => void | Promise<void>;
  onMessageOpen?: (creator: ICreator) => void;
  isTTASearch?: boolean;
  showMediaKitBtn?: boolean;
}

export const CreatorInfo: React.FC<ICreatorInfoProps> = ({
  creator,
  note,
  isProfile,
  isShared,
  onCheck,
  onNoteOpen,
  onNameClick,
  onRemoveFromList,
  onMessageOpen,
  isTTASearch,
  showMediaKitBtn,
}) => {
  return (
    <Box margin={4}>
      {/* 
      WARN: Do not try to use `useBreakpointValue` to conditionally display the mobile/desktop versions.
      It'll break the virtual scroll (height calculation) and create jumpy scroll issue.
      Ref: https://whalar.atlassian.net/browse/FOAM-6060
    */}
      <CreatorInfoMobile
        creator={creator}
        note={note}
        isProfile={isProfile}
        isShared={isShared}
        onCheck={onCheck}
        onNoteOpen={onNoteOpen}
        onNameClick={onNameClick}
        onRemoveFromList={onRemoveFromList}
        onMessageOpen={onMessageOpen}
        showMediaKitBtn={showMediaKitBtn}
        isTTASearch={isTTASearch}
      />

      <CreatorInfoDesktop
        creator={creator}
        note={note}
        isProfile={isProfile}
        isShared={isShared}
        onCheck={onCheck}
        onNoteOpen={onNoteOpen}
        onNameClick={onNameClick}
        onRemoveFromList={onRemoveFromList}
        onMessageOpen={onMessageOpen}
        showMediaKitBtn={showMediaKitBtn}
        isTTASearch={isTTASearch}
      />
      {isTTASearch && <TTAPostSnippet ttaContent={creator.ttaContents} />}
    </Box>
  );
};
